export default __webpack_public_path__ + "static/media/transcomahue.0f8781ba.png";